import { gql } from '@apollo/client'

const CREATE_AUTOMATED_GOAL = gql`
  mutation createAutomatedGoal(
    $appcuesFlowId: String!
    $nonprofitOrgId: Int!
    $createObjective: Boolean
    $shareWithFunderOrgId: Int
    $isGoalSharedByFunder: Boolean
  ) {
    createAutomatedGoal(
      appcuesFlowId: $appcuesFlowId
      nonprofitOrgId: $nonprofitOrgId
      createObjective: $createObjective
      shareWithFunderOrgId: $shareWithFunderOrgId
      isGoalSharedByFunder: $isGoalSharedByFunder
    ) {
      templateLibraryId
      objective {
        id
        title
      }
      goal {
        id
        title
        category
        type
        owner {
          id
          firstName
          lastName
        }
      }
      checklistItems {
        id
        title
      }
    }
  }
`

export default CREATE_AUTOMATED_GOAL
